/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResponsiblePersonRepeater/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import Repeater from 'DesignSystem/Repeater/index'



/** @type {import('Simple/types.js').View} */
export default function ResponsiblePersonRepeater({
  children,
  viewPath = "/App/Form/Data/ReviewData/ResponsiblePersonRepeater",
  text
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<Repeater
  viewPath={`${viewPath}/Repeater`}
 label="Responsible Person"
 onClick={() => setFlowTo("/App/Form/Data/ProvideData/ResponsiblePerson")}
 isSelected={flow.has("/App/Form/Data/ProvideData/ResponsiblePerson")}
 text={text}
/>
{children}
</React.Fragment>)
}